import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RoleRoute = ({ children, allowedRoles }) => {
  const { currentUser, userRole, userVerified, loading, fetchUserData } = useAuth();
  const [isChecking, setIsChecking] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const checkAccess = async () => {
      if (!loading && currentUser) {
        // Jika pengguna sudah login tapi userRole belum diatur, coba ambil data pengguna
        if (!userRole) {
          console.log('User logged in but role not set, fetching user data...');
          try {
            await fetchUserData(currentUser.uid);
          } catch (error) {
            console.error('Error fetching user data in RoleRoute:', error);
          }
        }
        
        // Periksa apakah peran pengguna diizinkan DAN pengguna sudah diverifikasi
        // Pengecualian untuk role 'pj' yang tidak perlu verifikasi
        const hasAllowedRole = allowedRoles.includes(userRole);
        const isVerifiedOrPJ = userVerified || userRole === 'pj';
        setHasAccess(hasAllowedRole && isVerifiedOrPJ);
      }
      setIsChecking(false);
    };

    checkAccess();
  }, [currentUser, userRole, userVerified, loading, fetchUserData, allowedRoles]);

  if (loading || isChecking) {
    return <div>Loading...</div>;
  }

  // Redirect to login if not authenticated
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Redirect to dashboard if role is not allowed or user is not verified
  if (!hasAccess) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default RoleRoute;
